import React, { useState, useEffect } from 'react';
import { Search, Filter, Edit, Save, X, ChevronDown, Check, RefreshCw } from 'lucide-react';
import subjectItemLoadService from '../../services/subjectItemLoadService';
import '../../styles/SubjectItemLoad.css';

const SubjectItemLoad = () => {
  const [subjectItems, setSubjectItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [sortBy, setSortBy] = useState('subject'); // 'subject' or 'class'
  const [searchTerm, setSearchTerm] = useState('');
  const [newLoad, setNewLoad] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  // Sample data based on the image format
  const sampleData = [
    { id: 1, subjectCode: 'A&D', classCode: '1A', subjectName: 'Art & Design', className: '1A', teachingLoad: 2, subjectGroup: 'Arts' },
    { id: 2, subjectCode: 'A&D', classCode: '1B', subjectName: 'Art & Design', className: '1B', teachingLoad: 2, subjectGroup: 'Arts' },
    { id: 3, subjectCode: 'A&D', classCode: '2A', subjectName: 'Art & Design', className: '2A', teachingLoad: 2, subjectGroup: 'Arts' },
    { id: 4, subjectCode: 'A&D', classCode: '2B', subjectName: 'Art & Design', className: '2B', teachingLoad: 2, subjectGroup: 'Arts' },
    { id: 5, subjectCode: 'A&D', classCode: '3A', subjectName: 'Art & Design', className: '3A', teachingLoad: 2, subjectGroup: 'Arts' },
    { id: 6, subjectCode: 'A&D', classCode: '3B', subjectName: 'Art & Design', className: '3B', teachingLoad: 2, subjectGroup: 'Arts' },
    { id: 7, subjectCode: 'A&D', classCode: '4A', subjectName: 'Art & Design', className: '4A', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 8, subjectCode: 'A&D', classCode: '4B', subjectName: 'Art & Design', className: '4B', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 9, subjectCode: 'A&D', classCode: '5A', subjectName: 'Art & Design', className: '5A', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 10, subjectCode: 'A&D', classCode: '5B', subjectName: 'Art & Design', className: '5B', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 11, subjectCode: 'A&D', classCode: '6A', subjectName: 'Art & Design', className: '6A', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 12, subjectCode: 'A&D', classCode: '6S', subjectName: 'Art & Design', className: '6S', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 13, subjectCode: 'A&D', classCode: '7A', subjectName: 'Art & Design', className: '7A', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 14, subjectCode: 'A&D', classCode: '7S', subjectName: 'Art & Design', className: '7S', teachingLoad: 0, subjectGroup: 'Arts' },
    { id: 15, subjectCode: 'AMA', classCode: '1A', subjectName: 'Applied Mathematics', className: '1A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 16, subjectCode: 'AMA', classCode: '1B', subjectName: 'Applied Mathematics', className: '1B', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 17, subjectCode: 'AMA', classCode: '2A', subjectName: 'Applied Mathematics', className: '2A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 18, subjectCode: 'AMA', classCode: '2B', subjectName: 'Applied Mathematics', className: '2B', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 19, subjectCode: 'AMA', classCode: '3A', subjectName: 'Applied Mathematics', className: '3A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 20, subjectCode: 'AMA', classCode: '3B', subjectName: 'Applied Mathematics', className: '3B', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 21, subjectCode: 'AMA', classCode: '4A', subjectName: 'Applied Mathematics', className: '4A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 22, subjectCode: 'AMA', classCode: '4B', subjectName: 'Applied Mathematics', className: '4B', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 23, subjectCode: 'AMA', classCode: '5A', subjectName: 'Applied Mathematics', className: '5A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 24, subjectCode: 'AMA', classCode: '5B', subjectName: 'Applied Mathematics', className: '5B', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 25, subjectCode: 'AMA', classCode: '6A', subjectName: 'Applied Mathematics', className: '6A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 26, subjectCode: 'AMA', classCode: '6S', subjectName: 'Applied Mathematics', className: '6S', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 27, subjectCode: 'AMA', classCode: '7A', subjectName: 'Applied Mathematics', className: '7A', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 28, subjectCode: 'AMA', classCode: '7S', subjectName: 'Applied Mathematics', className: '7S', teachingLoad: 0, subjectGroup: 'Mathematics' },
    { id: 29, subjectCode: 'ENG', classCode: '1A', subjectName: 'English', className: '1A', teachingLoad: 8, subjectGroup: 'Languages' },
    { id: 30, subjectCode: 'ENG', classCode: '1B', subjectName: 'English', className: '1B', teachingLoad: 8, subjectGroup: 'Languages' },
    { id: 31, subjectCode: 'ENG', classCode: '2A', subjectName: 'English', className: '2A', teachingLoad: 8, subjectGroup: 'Languages' },
    { id: 32, subjectCode: 'ENG', classCode: '2B', subjectName: 'English', className: '2B', teachingLoad: 8, subjectGroup: 'Languages' },
    { id: 33, subjectCode: 'ENG', classCode: '3A', subjectName: 'English', className: '3A', teachingLoad: 8, subjectGroup: 'Languages' },
    { id: 34, subjectCode: 'ENG', classCode: '3B', subjectName: 'English', className: '3B', teachingLoad: 8, subjectGroup: 'Languages' },
    { id: 35, subjectCode: 'MATH', classCode: '1A', subjectName: 'Mathematics', className: '1A', teachingLoad: 6, subjectGroup: 'Mathematics' },
    { id: 36, subjectCode: 'MATH', classCode: '1B', subjectName: 'Mathematics', className: '1B', teachingLoad: 6, subjectGroup: 'Mathematics' },
    { id: 37, subjectCode: 'MATH', classCode: '2A', subjectName: 'Mathematics', className: '2A', teachingLoad: 6, subjectGroup: 'Mathematics' },
    { id: 38, subjectCode: 'MATH', classCode: '2B', subjectName: 'Mathematics', className: '2B', teachingLoad: 6, subjectGroup: 'Mathematics' },
    { id: 39, subjectCode: 'MATH', classCode: '3A', subjectName: 'Mathematics', className: '3A', teachingLoad: 6, subjectGroup: 'Mathematics' },
    { id: 40, subjectCode: 'MATH', classCode: '3B', subjectName: 'Mathematics', className: '3B', teachingLoad: 6, subjectGroup: 'Mathematics' },
    { id: 41, subjectCode: 'CHI', classCode: '1A', subjectName: 'Chinese', className: '1A', teachingLoad: 6, subjectGroup: 'Languages' },
    { id: 42, subjectCode: 'CHI', classCode: '1B', subjectName: 'Chinese', className: '1B', teachingLoad: 6, subjectGroup: 'Languages' },
    { id: 43, subjectCode: 'CHI', classCode: '2A', subjectName: 'Chinese', className: '2A', teachingLoad: 6, subjectGroup: 'Languages' },
    { id: 44, subjectCode: 'CHI', classCode: '2B', subjectName: 'Chinese', className: '2B', teachingLoad: 6, subjectGroup: 'Languages' },
    { id: 45, subjectCode: 'CHI', classCode: '3A', subjectName: 'Chinese', className: '3A', teachingLoad: 6, subjectGroup: 'Languages' },
    { id: 46, subjectCode: 'CHI', classCode: '3B', subjectName: 'Chinese', className: '3B', teachingLoad: 6, subjectGroup: 'Languages' },
    { id: 47, subjectCode: 'PHY', classCode: '4A', subjectName: 'Physics', className: '4A', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 48, subjectCode: 'PHY', classCode: '4B', subjectName: 'Physics', className: '4B', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 49, subjectCode: 'PHY', classCode: '5A', subjectName: 'Physics', className: '5A', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 50, subjectCode: 'PHY', classCode: '5B', subjectName: 'Physics', className: '5B', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 51, subjectCode: 'PHY', classCode: '6A', subjectName: 'Physics', className: '6A', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 52, subjectCode: 'PHY', classCode: '6S', subjectName: 'Physics', className: '6S', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 53, subjectCode: 'PHY', classCode: '7A', subjectName: 'Physics', className: '7A', teachingLoad: 4, subjectGroup: 'Sciences' },
    { id: 54, subjectCode: 'PHY', classCode: '7S', subjectName: 'Physics', className: '7S', teachingLoad: 4, subjectGroup: 'Sciences' },
  ];

  useEffect(() => {
    loadSubjectItemLoads();
  }, []);

  const loadSubjectItemLoads = async () => {
    setLoading(true);
    try {
      const data = await subjectItemLoadService.getSubjectItemLoads();
      if (data && data.length > 0) {
        // Transform Supabase data to component format
        const transformedData = data.map(item => ({
          id: item.id,
          subjectCode: item.subject_code,
          classCode: item.class_code,
          subjectName: item.subject_name,
          className: item.class_name,
          teachingLoad: item.teaching_load,
          subjectGroup: item.subject_group
        }));
        setSubjectItems(transformedData);
      } else {
        // Use sample data if no data from Supabase
        setSubjectItems(sampleData);
      }
    } catch (error) {
      console.error('Error loading subject item loads:', error);
      // Fallback to sample data
      setSubjectItems(sampleData);
    } finally {
      setLoading(false);
    }
  };

  // Filter and sort data
  useEffect(() => {
    let filtered = subjectItems.filter(item => 
      item.subjectCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.classCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.subjectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.className.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort data
    filtered.sort((a, b) => {
      if (sortBy === 'subject') {
        return a.subjectCode.localeCompare(b.subjectCode) || a.classCode.localeCompare(b.classCode);
      } else {
        return a.classCode.localeCompare(b.classCode) || a.subjectCode.localeCompare(b.subjectCode);
      }
    });

    setFilteredItems(filtered);
  }, [subjectItems, searchTerm, sortBy]);

  const handleItemSelect = (item) => {
    setSelectedItems(prev => {
      const isSelected = prev.some(selected => selected.id === item.id);
      if (isSelected) {
        return prev.filter(selected => selected.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedItems.length === filteredItems.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems([...filteredItems]);
    }
  };

  const handleModify = () => {
    if (selectedItems.length === 0) {
      alert('請先選擇要修改的科目項目 (Please select items to modify)');
      return;
    }
    setIsEditing(true);
  };

  const handleSave = async () => {
    if (!newLoad || isNaN(newLoad) || newLoad < 0) {
      alert('請輸入有效的授課節數 (Please enter a valid teaching load)');
      return;
    }

    setLoading(true);
    try {
      // Prepare updates for Supabase
      const updates = selectedItems.map(item => ({
        subjectCode: item.subjectCode,
        classCode: item.classCode,
        teachingLoad: parseInt(newLoad)
      }));

      // Update in Supabase
      await subjectItemLoadService.updateTeachingLoads(updates);

      // Update local state
      const updatedItems = subjectItems.map(item => {
        if (selectedItems.some(selected => selected.id === item.id)) {
          return { ...item, teachingLoad: parseInt(newLoad) };
        }
        return item;
      });

      setSubjectItems(updatedItems);
      setSelectedItems([]);
      setNewLoad('');
      setIsEditing(false);
      
      alert('授課節數已成功更新 (Teaching loads updated successfully)');
    } catch (error) {
      console.error('Error updating teaching loads:', error);
      alert('更新失敗，請重試 (Update failed, please try again)');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setSelectedItems([]);
    setNewLoad('');
    setIsEditing(false);
  };

  const formatItemDisplay = (item) => {
    return `${item.subjectCode}--${item.classCode}--${item.teachingLoad}`;
  };

  if (loading && subjectItems.length === 0) {
    return (
      <div className="subject-item-load-container">
        <div className="loading-container">
          <div className="loading-content">
            <RefreshCw className="loading-spinner" size={48} />
            <p className="loading-text">載入資料中... (Loading data...)</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="subject-item-load-container">
      {/* Header */}
      <div className="subject-item-load-header">
        <h2>班別科目授課節數編修 (Subject Item Load for Classes)</h2>
        <p className="subtitle">TBM0160E</p>
      </div>

      {/* Search and Filter Controls */}
      <div className="search-filter-section">
        <div className="search-filter-controls">
          <div className="search-input">
            <Search className="search-icon" size={16} />
            <input
              type="text"
              placeholder="搜尋科目或班別 (Search subjects or classes)..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="sort-controls">
            <label className="sort-label">排序方式 (Sort by):</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="sort-select"
            >
              <option value="subject">依科目排列 (By Subject)</option>
              <option value="class">依班別排列 (By Class)</option>
            </select>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="subject-item-load-content">
        {/* Left Panel - Subject Item List */}
        <div className="subject-item-list-panel">
          <div className="subject-item-list-header">
            <h3 className="subject-item-list-title">SubjItem-Class-Load</h3>
            <div className="subject-item-counter">
              {selectedItems.length}/{filteredItems.length}
            </div>
          </div>
          
          <div className="subject-item-list">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                onClick={() => handleItemSelect(item)}
                className={`subject-item-row ${
                  selectedItems.some(selected => selected.id === item.id) 
                    ? 'selected' 
                    : ''
                }`}
              >
                <div>
                  <div className="subject-item-code">{formatItemDisplay(item)}</div>
                  <div className="subject-item-details">
                    {item.subjectName} - {item.className}
                  </div>
                </div>
                <Check className="subject-item-check" size={16} />
              </div>
            ))}
          </div>
        </div>

        {/* Right Panel - Controls */}
        <div className="subject-item-controls-panel">
          {/* Selected Items */}
          <div className="control-section">
            <h4 className="control-section-title">Selected</h4>
            <div className="selected-items-display">
              {selectedItems.length === 0 ? (
                <div className="no-selection">
                  No item selected
                </div>
              ) : (
                selectedItems.map((item) => (
                  <div key={item.id} className="selected-item">
                    {formatItemDisplay(item)}
                  </div>
                ))
              )}
            </div>
          </div>

          {/* New Load Input */}
          <div className="control-section">
            <h4 className="control-section-title">New Load</h4>
            <div className="new-load-input">
              <input
                type="number"
                value={newLoad}
                onChange={(e) => setNewLoad(e.target.value)}
                placeholder="Enter teaching load"
                className="new-load-field"
                min="0"
              />
              <button className="new-load-dropdown">
                <ChevronDown size={16} />
              </button>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="action-buttons">
            <button
              onClick={handleModify}
              disabled={selectedItems.length === 0}
              className="action-button primary"
            >
              <Edit size={16} />
              Modify
            </button>
            
            {isEditing && (
              <div className="action-button-group">
                <button
                  onClick={handleSave}
                  className="action-button success"
                >
                  <Save size={16} />
                  Save
                </button>
                <button
                  onClick={handleCancel}
                  className="action-button danger"
                >
                  <X size={16} />
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Instructions */}
      <div className="instructions-section">
        <h5 className="instructions-title">使用說明 (Instructions):</h5>
        <ol className="instructions-list">
          <li>使用者可利用下拉式選單選擇依科目排列或依班別排列</li>
          <li>在科目列表中選取需修改的班別科目 (可同時選取多項班別科目)</li>
          <li>使用者可按「編修」鍵編修班別科目授課節數</li>
          <li>在「更新課節」欄位鍵入該班別科目的授課節數 (所有已選取的班別科目都會改為此授課節數)</li>
          <li>輸入完成後, 按「儲存」鍵紀錄資料或按「取消」鍵取消儲存資料</li>
          <li>系統會顯示修改後的結果</li>
        </ol>
      </div>
    </div>
  );
};

export default SubjectItemLoad;